import { CloseIcon } from 'assets/icons/CloseIcon'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { ISelectValue } from 'constants/globalTypes'
import { createFoodInventoryItem, editFoodInventoryItem } from 'features/food/foodSlice'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { CursorPointer, Flex } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { TitleText } from 'styling/Typography'
import { standardFieldValidation, validateSelect } from 'utils/validationUtils'
import { addFoodItemModalInvalidFields } from '../foodData'

export const AddFoodItemModal = ({ closeModal, values }: IAddFoodItemModal) => {

    const dispatch = useDispatch<AppDispatch>()
    const [state, setState] = useState<IAddFoodItemModalState>(values || {
        name: '',
        ingredient: null,
        category: null,
        amount: null,
        price: null,
    })
    const [invalidFields, setInvalidFields] = useState(values?.id ? [] : addFoodItemModalInvalidFields)

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, valueAsNumber } = e.target
        standardFieldValidation(e, setInvalidFields)
        setState(prev => {
            const copy = structuredClone(prev)
            copy[name] = (name == 'name' ? value : valueAsNumber)
            return copy
        })
    }

    const handleSelect = (v: ISelectValue, n: string) => {
        validateSelect(v, n, setInvalidFields)
        setState(prev => ({ ...prev, [n]: v }))
    }

    const handleSave = async () => {
        const resp = await dispatch(values?.id ? editFoodInventoryItem(state) : createFoodInventoryItem(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }

    return <Modal black >
        <Flex column gap='1rem' >
            <Flex between width='100%' center >
                <TitleText weight='bold' >{values?.id ? 'Edit' : 'Add'} Item</TitleText>
                <CursorPointer onClick={closeModal} >
                    <CloseIcon />
                </CursorPointer>
            </Flex>
            <Input placeholder='Enter item name' labelText='Item name' name='name' value={state?.name} onChange={handleChange} nomarg invalid={!state?.name} />
            <HonestSelectAsyncInput
                link='food/management/ingredient'
                name='ingredient'
                labelText='Ingredient'
                placeholder='Flour, sugar, salt...'
                defaultValue={state?.ingredient?.label}
                onChange={handleSelect}
                invalid={!state?.ingredient}
                parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.name, value: i.id }))}
                nomarg
            />
            <HonestSelectAsyncInput
                link='food/inventory/category'
                name='category'
                labelText='Category'
                placeholder='Enter category'
                defaultValue={state?.category?.label}
                onChange={handleSelect}
                invalid={!state?.category}
                parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.name, value: i.id }))}
                nomarg
            />
            <Flex width='100%' gap='1rem' >
                <Input placeholder='15' labelText='Amount' value={state?.amount} onChange={handleChange} nomarg name='amount' invalid={!state?.amount} type='number' />
                <Input placeholder='15' labelText='Price' value={state?.price} onChange={handleChange} nomarg invalid={!state?.price} name='price' type='number' />
            </Flex>

            <Flex width='100%' center justcenter >
                <Button variant='primary' disabled={!!invalidFields.length} onClick={handleSave} >Save</Button>
            </Flex>
        </Flex>
    </Modal>
}

export interface IAddFoodItemModal {
    closeModal: () => void
    values: IAddFoodItemModalState
}

export interface IAddFoodItemModalState {
    id?: number
    name: string
    ingredient: ISelectValue
    category: ISelectValue
    amount: number
    price: number
}